export default {
    correct_answers: "Respuestas correctas",
    drag_and_drop: "Arrastrar y soltar",
    drag_the_words_description: "El jugador debe elegir las palabras disponibles y arrastrarlas al campo de palabras en el texto, hasta que se utilicen todas las palabras disponibles.",
    drag_the_words_failure_message: "Lástima que no lo lograste. ¡Inténtalo de nuevo!",
    drag_the_words_instructions: "Verá un texto con espacios en blanco y un campo con palabras para elegir. Debe arrastrar las palabras a los espacios en blanco hasta que no queden palabras en sus opciones.",
    drag_the_words_success_message: "¡Enhorabuena, tienes todas las palabras correctas y completaste el juego!",
    drag_the_words: "Arrastra las palabras",
    enigma_failure_message: "Lástima, no lo lograste. Inténtalo de nuevo.",
    enigma_instructions: "Mira los consejos y resuelve los acertijos!",
    enigma_success_message: "¡Felicitaciones, lograste seguir las pistas correctamente y resolviste el acertijo!",
    enigma: "Enigma",
    errors: "Errores",
    example: "Ejemplo",
    fill_in_the_blanks_failure_message: "Lástima que no lo lograste. ¡Inténtalo de nuevo!",
    fill_in_the_blanks_instructions: "El jugador debe completar todos los espacios en blanco en el texto. Al llenar todos los espacios, el jugador debe hacer clic en enviar para que finalice el juego.",
    fill_in_the_blanks_success_message: "¡Enhorabuena, tienes todas las palabras correctas y completaste el juego!",
    fill_in_the_blanks: "Rellenar los espacios",
    find_the_pairs_failure_message: "Que pena, sobrepasaste el limite de errores permitido. Intentar otra vez.",
    find_the_pairs_instructions: "El jugador tendrá dos columnas y debe hacer clic en una de las opciones en una columna, luego hacer clic en una de las opciones en la columna al lado. El juego terminará cuando se seleccionen todas las opciones.",
    find_the_pairs_success_message: "¡Felicitaciones, lograste encontrar los pares correctamente!",
    find_the_pairs: "Encuentra los pares",
    flashcards_failure_message: "Lástima, no lo lograste. Inténtalo de nuevo.",
    flashcards_instructions: "El jugador debe agregar una respuesta a cada flashcard, hasta que complete el juego.",
    flashcards_success_message: "¡Felicitaciones, tienes todas las flashcards correctas!",
    flashcards: "Flashcards",
    forfeit: "Rendirse",
    game_type: "Tipo de juego",
    games: "Juegos",
    infinite: "Infinito",
    instructions: "Instrucciones",
    play_again: "Juega de nuevo",
    play: "Jugar",
    qty_errors_allowed: "Número de errores permitidos",
    restart: "Reiniciar",
    result: "Resultado",
    that: "Aquella",
    this_or_blanks_success_message: "¡Felicitaciones, acertaste esto o aquello!",
    this_or_that_failure_message: "Lástima, no lo lograste. Inténtalo de nuevo.",
    this_or_that_instructions: "El jugador verá una descripción y deberá elegir la opción 'esto' o 'eso', hasta marcar todas las opciones disponibles.",
    this_or_that: "Esta o Aquella",
    this: "Esta",
    tip: "Consejo",
    true_or_false_failure_message: "Lástima que no lo lograste. Inténtalo de nuevo.",
    true_or_false_instructions: "Elige la opción de verdadero o falso para cada una de las oraciones.",
    true_or_false_success_message: "¡Felicitaciones, acertaste verdadero o falso!",
    true_or_false: "Verdadero o falso",
    words: "Palabras"
}